import * as React from "react";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import "dayjs/locale/ja";

import { defaultDateFormat } from "app/constants";

function DatePickerInput(props) {
  const { value, setValue, disabled, className, ...otherProps } = props;

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ja">
      <DatePicker
        value={value}
        className={className}
        onChange={(newValue) => setValue(newValue)}
        format={defaultDateFormat}
        disabled={disabled}
        sx={{
          "& .MuiInputBase-input": {
            padding: "6px 16px !important",
            lineHeight: "24px !important",
            height: "24px !important",
            fontSize: "16px",
          },
          "& .Mui-disabled": {
            backgroundColor: "#f3f4f6 !important",
          },
          "& input.Mui-disabled ": {
            color: "#000 !important",
            "-webkit-text-fill-color": "#000 !important",
          },
        }}
        {...otherProps}
      />
    </LocalizationProvider>
  );
}

export default DatePickerInput;
